import React, { ReactElement } from 'react';
import type { Route } from 'next';
import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Membership/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="dark" links={[{ title: 'Membership', href: '' as Route }]} />
        <h1 className={cn('header__title')}>Membership Information</h1>
        <div className={cn('header__description')}>
          <p className={cn('header__description-paragraph')}>
            Welcome to DFA! If you are a professional <Link href="/freight-forwarder">freight forwarder</Link>, we look forward to you
            joining our network and getting the most out of your business! The Digital Freight Alliance is the logistics
            association created in 2020 by DP World to unite logistics companies in one community, optimizing processes and
            using digital tools for logistics.
          </p>
          <p className={cn('header__description-paragraph')}>
            With Digital Freight Alliance we have two membership options:
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;